import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.function.name.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { store } from '@/store';
import { i18n } from '@/boot/i18n';
import { makeScreen } from "./_utils";
var type = 'comments';
export default {
  type: type,
  requiresTransaction: false,

  /**
   * Determines if a General Comments question should be added to the selection
   *
   * @param {Object} context
   *
   * @returns {Boolean} true if the question should be added to the selection, else false.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select() {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a General Comments Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", makeScreen(context, [{
                id: context.section.name,
                type: 'fib-comments',
                required: context.section.required,
                label: '',
                props: {
                  label: i18n.t('questions.comments.additionalComments'),
                  rows: 4
                }
              }]));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var comments = context.response; // there should only be 1 comments section, so let's just use the value (if any) from the first such response

    if (!comments.length || !comments[0].value) {
      return null;
    }

    return {
      comments: comments[0].value,
      mutateSubmit: function mutateSubmit(submit) {
        submit.generalComments = this.comments;
      }
    };
  },
  summary: {
    weight: 100,

    /**
     * Build summary content
     * @param {Object} context context
     */
    build: function build(_ref) {
      var builder = _ref.builder;
      var answer = store.getters['answers/firstAnswerOfType'](type);

      if (answer !== null && answer !== void 0 && answer.comments) {
        builder.comments(i18n.tc('checkout.shareComment', answer.comments));
      }
    }
  }
};